import { apiWrapper, apiCancel } from '../../wrapper'

export const initial = 'SKP'
const baseUrl = process.env.REACT_APP_SERVICE_CORE_URL
const appCode = process.env.REACT_APP_SERVICE_CORE_APPCODE
const outputType = 'json'

export const skpListEmployee = 'Kepegawaian/SKP/listEmployee/'
export const skpListHeader = 'Kepegawaian/SKP/listHeader/'
export const skpListTarget = 'Kepegawaian/SKP/listTarget/'
export const skpCreateHeader = 'Kepegawaian/SKP/createHeader/'
export const skpUpdateHeader = 'Kepegawaian/SKP/updateHeader/'
export const skpDetailHeader = 'Kepegawaian/SKP/detailHeader/'
export const skpInitialHeader = 'Kepegawaian/SKP/initialHeader/'
export const skpDeleteHeader = 'Kepegawaian/SKP/deleteHeader/'
export const skpDeleteKegiatan = 'Kepegawaian/SKP/deleteKegiatan/'
export const skpDetailEmployee = 'Kepegawaian/SKP/get_empDetail/'
export const skpIku = 'Kepegawaian/SKP/get_iku/'
export const skpCreateKegiatan = 'Kepegawaian/SKP/createKegiatan/'
export const skpCreateTugasTambahan = 'Kepegawaian/SKP/createTugasTambahan/'
export const skpInputRealisasi = 'Kepegawaian/SKP/inputRealisasi/'
export const skpGetEmpType = 'Kepegawaian/SKP/get_emptype/'
export const skpDetail = 'Kepegawaian/SKP/get_SKPdetail/'
export const skpAllEmployee = 'Kepegawaian/SKP/get_employee/'
export const skpUpdateStatus = 'Kepegawaian/SKP/updateStatusPeriode/'
export const skpListEmployeeBawahan = 'Kepegawaian/SKP/listEmployeeSKPBawahan/'
export const skpSikap = 'Kepegawaian/SKP/get_sikapPegawai/'
export const skpPeriod = 'Kepegawaian/SKP/get_period/'
export const skpPeriodAll = 'Kepegawaian/SKP/get_periodAll/'
export const skpCreateBehavior = 'Kepegawaian/SKP/createBehavior/'
export const skpPeriodCheck = 'Kepegawaian/SKP/kegiatancheck/'
export const skpUpdateTarget = 'Kepegawaian/SKP/updateTarget/'
export const skpListTugasTambahan = 'Kepegawaian/SKP/listTugasTambahan/'
export const skpPengukuranList = 'Kepegawaian/SKP/listPengukuran/'
export const skpApprovalPengukuran = 'Kepegawaian/SKP/approvalPengukuran/'
export const skpGetEmployee = 'Kepegawaian/SKP/get_empemployee/'
export const skpDownload = 'Kepegawaian/SKP/downloadSKP/'
export const skpPositionHistory = 'Kepegawaian/SKP/get_emppositionhistory/'
export const skpPositionHistoryDetail = 'Kepegawaian/SKP/get_emppositionhistorydetail/'
export const skpListEmployeeBawahanBelumbuat = 'Kepegawaian/SKP/get_belumbuat_skp/'
export const skpGettimeUnit = 'Kepegawaian/SKP/get_time_unit/'
export const skpGetRankGroup = 'Kepegawaian/SKP/get_rank_group/'
export const skpGetPeriodDetail = 'Kepegawaian/SKP/skpGetPeriodDetail/'

/* MI ----------------------------> */
export const skpListPeriodBawahan = 'Kepegawaian/SKP/listPeriodBawahan/'
export const skpListDataApproval = 'Kepegawaian/SKP/listDataApproval/'
export const skpApprovalTarget = 'Kepegawaian/SKP/approvalTarget/'
export const skpApprovalRealisasi = 'Kepegawaian/SKP/approvalRealisasi/'
export const skpDetailPeriod = 'Kepegawaian/SKP/detailPeriod/'
/* ---------------------------> MI */

export const masterRank = 'Master/List/rank/'
export const masterEducation = 'Master/List/education/'
export const masterEducationGroup = 'Master/List/EducationGroup/'
export const masterEchelon = 'Master/List/echelon/'
export const masterPosition = 'Master/List/position/'
export const masterPositionGrade = 'Master/List/positionGrade/'
export const masterWorkUnit = 'Master/List/workUnit/'
export const getSimantab = 'Kepegawaian/SKP/get_simantab/'

//export const cancelToken = () => apiCancel
export const cancelToken = () => {
    return apiCancel()
}
export const apiRequest = async (method, route, data = { params: null, body: null, cancelToken: null }, needToken=true) => {
    if(needToken) {
        const thisTime = (Math.floor(Date.now()/1000))
        const expire = localStorage.getItem(initial + 'accessExpired')
        if(expire < thisTime) {
           await apiWrapper(baseUrl, initial, appCode, outputType, 'post', 'auth/getAccessToken/', data)
           .then(result => {
                localStorage.setItem(initial + 'accessToken', result.response.access_token)
                return apiWrapper(baseUrl, initial, appCode, outputType, method, route, data)
            })
            .catch(result => {
                return Promise.reject('Tidak dapat mengambil accessToken');
            })
        } else {
            return apiWrapper(baseUrl, initial, appCode, outputType, method, route, data)        
        }
    }
    return apiWrapper(baseUrl, initial, appCode, outputType, method, route, data)
}